import type { SVGProps } from 'react'

export const LineChart = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M18 19H6.52941C5.68474 19 5 18.3153 5 17.4706V6"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M18 7L14.5 12.5L11.3992 10.6L8 15" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)
